import template from './imageLibraryItem.html';

export const ImageLibraryItemModule = angular
    .module('app.component.imageLibrary.imageLibraryItem', [])
    .component('imageLibraryItem', {
        bindings: {
            onImageToggle: '&',
            onSelectAndUse: '&',
            image: '<',
            index: '<'
        },
        template
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/imageLibraryItem.component.js